import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QRecordLookupRFC extends QRFC {
  constructor() {
    super();
  }

  InitRecordLookup(callbackObj, resolve = undefined, reject = undefined) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
    this.fResolve = resolve;
    this.fReject = reject;
  }

  GetCallName() {
    return "qrecordlookup";
  }

  SetParams(orgName, recordID, chartID, userName, handlePositions = false, fetchConfig = {}) {
    this.AddEncodedParameter("chartID", chartID);
    this.AddEncodedParameter("userID", userName);
    this.AddEncodedParameter("orgID", orgName);
    this.AddEncodedParameter("recordIDs", JSON.stringify(recordID));
    this.AddEncodedParameter("handlePositions", handlePositions);

    this.AddEncodedParameter("fetchConfig", JSON.stringify(fetchConfig));
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    callBackObj?.SvrQueryResult(success, r["data"]);
    if (this.fResolve) this.fResolve(r);
  }

  DoSessionEnded(response, callBackObj) {
    if (this.fReject) {
      this.fReject(response);
    } else {
      super.DoSessionEnded(response, callBackObj);
    }
  }
}
